module.exports = __webpack_public_path__ + "images/柏纳s长图_08-5.jpg?v=36dcf174";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_08-5.jpg
 ** module id = 171
 ** module chunks = 1 2
 **/